import React, { Component } from 'react';

class IconUserProfile extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 36 42"
                style={{
                    width: "70%",
                    height: "70%"
                }}
            >
                <path
                    fill={this.props.isActive ? "#fff" : "#1D53A5"}
                    d="M18 21c5.681 0 10.286-4.7 10.286-10.5S23.68 0 18 0C12.319 0 7.714 4.7 7.714 10.5S12.32 21 18 21zm7.2 2.625h-1.342A13.764 13.764 0 0118 24.938c-2.09 0-4.066-.476-5.858-1.313H10.8C4.837 23.625 0 28.563 0 34.65v3.413C0 40.236 1.728 42 3.857 42h28.286C34.273 42 36 40.236 36 38.062V34.65c0-6.087-4.837-11.025-10.8-11.025z"
                ></path>
            </svg>
        );
    }
}

export default IconUserProfile;